import db from '@/api/dbWeb';

const model = {
  // 变更记录搜索
  getChangeRecord(param) {
    return db.post('/changeLog/search', param);
  },
};
export default model;
